import { CheckCircleFillIcon, InfoIcon, XCircleFillIcon } from '@primer/octicons-react';
import toast, { type ToastOptions } from 'react-hot-toast';

export function successToast(message: string) {
  return toast.success(message, { icon: <CheckCircleFillIcon /> });
}

export function errorToast(message: string) {
  return toast.error(message, { icon: <XCircleFillIcon /> });
}

export function infoToast(message: string, options?: Pick<ToastOptions, 'duration'>) {
  return toast(message, { icon: <InfoIcon />, ...options });
}
